<script>
import { required } from 'vuelidate/lib/validators'

import FileEntry from './file_entry'


export default {
	components: { FileEntry },

	props: {
		indicatorsFile: {
			type: Array,
			required: true
		}
	},
	methods: {
		onFiltered(filteredItems) {

		},
	}
}
</script>

<template>
	<b-card no-body class="mb-0 shadow-none">
		<b-card-body>
			<div v-for="fartifacts in indicatorsFile" class="row justify-content-sm-between mt-0 border-bottom pt-2 pb-2">
				<FileEntry :fartifacts="fartifacts" />
				<!-- {{ fartifacts }} -->
			</div>
		</b-card-body>
	</b-card>
</template>


<style>
	.incident-status {
		width: 15%;
	}
	.incident-description {
		width: 35%;
	}
</style>